export const atPath = (path: string) =>
  window ? window.location.pathname.indexOf(path) === 0 : false
